import React, { useEffect, useState ,useRef} from "react";
import "./style2.scss";
import useFetch from "../../cache/useFetch";
import { useNavigate } from "react-router-dom";
import { GET, HEADER, HEADER_URL } from "../../helper/constants";
import { ParentMenu } from "../Tree/ParentMenu";
import HEADER_DATA from "../../constants/data-header";
import { cdnImage } from "../../helper/constants";

const Header2 = () => {
  const navigate = useNavigate();
  const [scrolltopdata, setscrolltopdata] = useState('');
  const [mainHeader, setMainHeader] = useState([]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 350) {
        setscrolltopdata('scrolled')
      }
      else {
        setscrolltopdata('')
      }
    });
  }, []);

  useEffect(() => {
    setToggle(false);
  }, [window.location.href])
  
  const { data: data } = useFetch({
    url: HEADER_URL,
    method: GET,
    key: HEADER,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });
  useEffect(() => {
   if(!data) {
    setMainHeader(HEADER_DATA)
   }
   else {
    setMainHeader(data)
   }
  }, [data])
  

  const [isActive, setActive] = useState(false);
  const base_link = "";
  const [toggle, setToggle] = useState(false);
  const [childMenu, setchildMenu] = useState([]);
  const [selectedElement, setSelectedElement] = useState('')
  const top_head = document.querySelector(".top-menu")

  const toggleClass = () => {
    setActive(!isActive);
    if(isActive) {
      top_head.classList.remove("active")
    }
    else {
      top_head.classList.add("active")
    }
  }

  useEffect(() => {
    setToggle(false)
    setActive(false);
   },[window.location.href])


  const handalLinkToggle = (item) => {
    top_head.classList.remove("active")
    setSelectedElement(item?.name)
    if (item.link == '' || !item.link) {
      setToggle(true)
      setchildMenu(item.child)
    }
    else {
      setToggle(false)
      if(item?.target){
        window.open(item.link, "_blank");
        return
      }
      navigate(item.link)
    }
  }

  const handalLinkTopMenu = (item) => {
    navigate(item.link)
    if(item.link=="https://developers.airtel.africa") {
      window.open(item.link, "_blank");
      navigate("/")
    }
    top_head.classList.remove("active")
  }
  return (
   
    <header className={`header ${scrolltopdata} ${isActive ? 'active' : ''}`}>
      <div className="top-menu"> 
        <div className="container">
          <ul>
            {!!mainHeader?.top_header?.length && mainHeader?.top_header.map((menu, idx) => (
              <li key={idx}>
                <a onClick={()=>handalLinkTopMenu(menu)}> {menu.name}</a>
              </li>
            ))}
          </ul>
        </div> </div>

      <div className="maine-menu" >
        <div className="container">
          <div className="top-wrap">
            <a className="logo" crossOrigin="anonymous" target="_self" href="/">
              <img alt="airtel_logo" src={ process.env.REACT_APP_DEFAULT_LANGAUAGE=='en-US'?`${cdnImage}assets/images/logo.svg`:`${cdnImage}assets/images/airtel-french-logo.svg`} />
            </a>
            <div onClick={toggleClass} id="nav-wrap">
              <img className="menu visible-xs" alt="Menu" src="assets/images/mobile-Menu.svg" />
            </div>
          </div>


          <ul className="main-nav">
            {!!mainHeader?.main_header?.length && mainHeader?.main_header.map((menu, idx) => (
              <li key={idx}>
                <a
                  className={menu?.child?.length > 0 ? 'mega-menu-link submenu_arrow_link' : 'mega-menu-link'}
                  data-i18n={menu.id}
                  data-mega-menu={menu.id}
                  module-id="common"
                  onClick={() => handalLinkToggle(menu, idx)}
                  target="_self"
                >
                  {menu.name}
                </a>


              </li>
            ))}
            {!!mainHeader?.main_header?.length && toggle && <>
              <div className={`mega-wrapper ${scrolltopdata}`}>
                <a onClick={() => setToggle(false)} class="mega-menu-close close hidden-xs" href="javascript:void(0);"><i class="icon-outlined-cross"></i></a>
                <a onClick={() => {
                  setToggle(false); top_head.classList.add("active")
                } } class="mega-menu-close back visible-xs " href="javascript:void(0);"><i class="icon-outlined-link-right-arrow"></i></a>
                <div className="container">
                  <span className="top-heading"> {selectedElement}</span>
                  <ul className="sub-menu sub-menu-1"><ParentMenu childMenu={childMenu} /></ul>
                </div>
              </div>
            </>
            }
          </ul>

        </div>
      </div>
    </header>
  );
};

export default Header2;

